import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useAccount } from '@gobob/sats-wagmi';
import { Button } from '@sovryn/ui';
import { ButtonStyle } from '@sovryn/ui';
import { tracker } from 'utils/tracker';
import { BtcFaucetTracker } from 'components/BtcFaucetTracker.tsx/BtcFaucetTracker';
import { toast } from 'react-toastify';
import { CaptchaVerification } from 'components/CaptchaVerification/CaptchaVerification';
import { nanoid } from 'nanoid';
export const FaucetLink = ({ className }) => {
    const { address: btcAddress } = useAccount();
    const [isTrackerOpen, setIsTrackerOpen] = useState(false);
    const [showCaptcha, setShowCaptcha] = useState(false);
    const onRequest = useCallback((token) => {
        if (!btcAddress)
            return;
        setIsTrackerOpen(true);
        let idempotencyKey = tracker.getIdempotencyKey();
        if (!idempotencyKey) {
            idempotencyKey = nanoid();
            tracker.setIdempotencyKey(idempotencyKey);
        }
        const body = new FormData();
        body.append('cf-turnstile-response', token);
        body.append('idempotency_key', idempotencyKey);
        fetch(`https://giver-campaign.bitcoinos.build/?address=${btcAddress}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
            },
            body,
        })
            .then(response => response.json())
            .then(data => {
            if (data?.txid) {
                tracker.trackBtcFaucetAirdrop(data.txid);
                setIsTrackerOpen(true);
            }
            if (data?.error && data.error.includes('Rate limit exceeded')) {
                toast.error('Rate limit exceeded, pls try again later.');
            }
        })
            .catch(error => {
            console.error('Error calling faucet:', error);
        });
    }, [btcAddress]);
    const onBegin = useCallback(() => {
        if (!btcAddress)
            return;
        if (tracker.isCaptchaTokenValid()) {
            const storedToken = tracker.getCaptchaToken();
            onRequest(storedToken);
        }
        else {
            setShowCaptcha(true);
        }
    }, [btcAddress, onRequest]);
    const onCaptchaVerified = useCallback(() => {
        const token = tracker.getCaptchaToken();
        if (token) {
            setShowCaptcha(false);
            onRequest(token);
        }
        else {
            console.error('CAPTCHA verification failed. Please try again.');
        }
    }, [onRequest]);
    const onCaptchaError = useCallback(() => {
        setShowCaptcha(false);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { style: ButtonStyle.ghost, text: "Get test BTC", className: className, disabled: !btcAddress, onClick: onBegin }), showCaptcha && (_jsx(CaptchaVerification, { btcAddress: btcAddress, onVerified: onCaptchaVerified, onError: onCaptchaError })), _jsx(BtcFaucetTracker, { open: isTrackerOpen, onClose: () => setIsTrackerOpen(false) })] }));
};
